import Vue from 'vue'
import env from '../../../config/prod.env.js'

const state = {
  comments: []
}

const mutations = {  
  SET_COMMENTS (state, payload) {
    state.comments = payload
  },
  ADD_COMMENT (state, payload) {
    state.comments.push(payload)
  },
  CLEAN (state) {
    state.comments = []
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  
  commentsByType: (context, data) => {
    const { user_evaluated, type } = data
    return Vue.http.get(`${env.API}/api/guideline-comment/by-week/${user_evaluated}/${type}`)
      .then((response) => {        
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addComment: (context, data ) => {
    const { comment, type, user_id, user_evaluated } = data
    let body = {comment, type, user_id}
    if (comment != '' && comment != undefined) {
      return Vue.http.post(`${env.API}/api/guideline-comment/new/${user_evaluated}`, body)    
        .then((response) => {        
          return response.body.success
        })
        .catch((error) => {
          return context.commit('API_FAILURE', error)
        })
    } else {
      return true
    }
  },
  commentsByTypeWeek: (context, data) => {
    const { user_evaluated, type } = data
    return Vue.http.post(`${env.API}/api/guideline-comment/by-type-week`, data)
      .then((response) => {        
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
}

const getters = {
  getComments: (state) => state.comments
}

export const guidelinecomment = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/guideline_comment.js